import { Injectable } from '@angular/core';
import { environment } from '../../../../environments/environment';

declare const ga: any;

@Injectable({
  providedIn: 'root',
})
export class GoogleAnalyticsClient {
  readonly exchangeV2TrackingID: string;

  constructor() {
    this.exchangeV2TrackingID = environment.gaMeasurementId;
  }

  create(): void {
    if (typeof ga === 'undefined') {
      return;
    }

    ga('create', {trackingId: this.exchangeV2TrackingID, cookieDomain: 'auto'});
  }

  sendPageView(url: string): void {
    if (typeof ga === 'undefined') {
      return;
    }

    ga('send', {hitType: 'pageview', page: url});
  }

  sendEvent(category: string, action: string, label?: string, value?: number): void {
    if (typeof ga === 'undefined') {
      return;
    }

    ga('send', {
      hitType: 'event',
      eventCategory: category,
      eventAction: action,
      eventLabel: label,
      eventValue: value,
    });
  }
}
